export const basicurl= "https://patient.insulin.docsun.health";
export const backurl= "https://patient.basic.docsun.health";